"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentConsentService = void 0;
class DocumentConsentService {
    constructor(documentConsentClient, loggingFacade) {
        this.documentConsentClient = documentConsentClient;
        this.loggingFacade = loggingFacade;
    }
    async getDocumentConsentRequired(isWcar, documentId, userId) {
        try {
            return await this.documentConsentClient.getDocumentConsentRequired(isWcar, documentId, userId);
        }
        catch (error) {
            this.loggingFacade.error(`Could not fetch document from document-consent for id ${documentId}`, error);
            return undefined;
        }
    }
    async postDocumentConsent(isWcar, userId, versionDetailsId, decision) {
        try {
            return await this.documentConsentClient.postDocumentConsent(isWcar, userId, versionDetailsId, decision);
        }
        catch (error) {
            this.loggingFacade.error(`Could not post document consent for version details id: ${versionDetailsId}`, error);
            return undefined;
        }
    }
    async putDocumentConsent(isWcar, userId, consentId, decision) {
        try {
            return await this.documentConsentClient.putDocumentConsent(isWcar, userId, consentId, decision);
        }
        catch (error) {
            this.loggingFacade.error(`Could not put document consent for document id: ${consentId}`, error);
            return undefined;
        }
    }
}
exports.DocumentConsentService = DocumentConsentService;
//# sourceMappingURL=DocumentConsentService.js.map